(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reviews"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector('.reviews-sectionn .reviews-right');

    // Optional: Snap slides after scroll
    slider.addEventListener('scroll', () => {
      const slides = document.querySelectorAll('.reviews-sectionn .reviews-right .review-slide');
      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        if (rect.left <= 0 && rect.right >= window.innerWidth) {
          slide.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
